<template>
  <div id="template-master" class="flex">
    <!-- メイン -->
    <div class="left-area mr-4">
      <div class="flex items-center mb-4">
        <div class="w-1/2">
          <common-button
            class="mr-4"
            title="必要情報マスター一覧"
            :click="clickRequiredInfoButton"
          ></common-button>
        </div>
        <div class="w-1/2">
          <common-button
            title="損害テンプレート一覧"
            :click="clickClaimTypeButton"
          ></common-button>
        </div>
      </div>
      <div class="header mb-4">
        <span>損種テンプレート作成の流れ</span>
      </div>
      <div class="mb-4">
        <p>
          事故ページの損種（必要情報）ページ（タブ）を作成するためには、テンプレートを事前に作成し、登録しておく必要があります。
        </p>
        <p>
          事前登録しておくことで、事故発生後に事故ページを作成する際、テンプレートを一から作成する必要がなく、スムーズに陸上管理者、サーベイヤーに
          事故ページを送信することができます。
        </p>
      </div>

      <!-- STEP1 -->
      <div class="step-area">
        <div class="mr-12">
          <div class="flex">
            <div class="step-label aisea-text-14-700-white">STEP</div>
          </div>
          <div class="step-number">01</div>
        </div>
        <div class="flex justify-between">
          <div>
            <div class="step-title">必要情報マスター登録</div>
            <div class="aisea-text-14-400-dark-gray">
              <p>
                事前にテンプレートを作成するために、必要情報名とそれに紐づく
              </p>
              <p>
                入力形式（１行テキスト、添付ファイル、プルダウンなど）を組み合わせてフォームパーツを作成し登録します。
              </p>
            </div>
          </div>
          <div class="image-area">
            <img :src="claimTypeImage" />
          </div>
        </div>
      </div>

      <!-- 三角 -->
      <div class="flex justify-center h-3">
        <div class="step-triangle"></div>
      </div>

      <!-- STEP2 -->
      <div class="step-area mb-4">
        <div class="mr-12">
          <div class="flex">
            <div class="step-label aisea-text-14-700-white">STEP</div>
          </div>
          <div class="step-number">02</div>
        </div>
        <div>
          <div class="flex justify-between mb-4">
            <div>
              <div class="step-title">損種テンプレート作成</div>
              <div>
                <div class="step-subtitle">損害マスター登録</div>
                <div class="aisea-text-14-400-dark-gray mb-4">
                  <p>
                    本システムでは事故対応に必要な情報を損種ごとに管理します。
                  </p>
                  <p>
                    ここでは、テンプレートを構成する要素である損種と事故対応ステップを作成し登録します。
                  </p>
                </div>
              </div>
            </div>
            <div class="image-area">
              <img :src="stepImage" />
            </div>
          </div>

          <div class="flex">
            <div>
              <div class="step-subtitle">損種テンプレートを作成</div>
              <div class="aisea-text-14-400-dark-gray mb-4">
                <p>
                  登録した損害種類•ステップを選択し、その損害種類に紐づく、必要情報を追加して、テンプレートを作成し登録します。
                </p>
                <p>
                  登録されたテンプレートは事故ページの損種（必要情報）のテンプレートとして利用することができます。
                </p>
              </div>
            </div>
            <div class="image-area">
              <img :src="requiredInfoImage" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- メニュー -->
    <div class="right-area">
      <hull-navigation-select
        class="mb-4"
        menuButtonLabel="メニュー"
        :menuItemOptions="getMenuItemOptions(this.$route.name)"
      >
      </hull-navigation-select>
    </div>
  </div>
</template>

<script>
import { ColorMixin, HullInsranceMixin } from "@/mixins";
import CommonButton from "../components/molecules/CommonButton.vue";

import HullNavigationSelect from "../components/molecules/HullNavigationSelect.vue";

export default {
  name: "T.TemplateManager",
  mixins: [ColorMixin, HullInsranceMixin],
  components: {
    CommonButton,
    HullNavigationSelect,
  },
  computed: {
    claimTypeImage() {
      return require("@/assets/images/hull-insurance/template-master/claim-type-image.png");
    },
    stepImage() {
      return require("@/assets/images/hull-insurance/template-master/step-image.png");
    },
    requiredInfoImage() {
      return require("@/assets/images/hull-insurance/template-master/required-info-image.png");
    },
  },
  methods: {
    clickClaimTypeButton() {
      this.$router.push({
        name: "hull-insurance-claim-type-list",
      });
    },
    clickRequiredInfoButton() {
      this.$router.push({
        name: "hull-insurance-required-info-list",
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/hull-insurance.scss";

$image-area-width: 200px;
#template-master {
  .header {
    background-color: $aisea-dark-blue;
    width: 100%;
    padding: 4px;
    font-size: 20px;
    font-family: $aisea-font-family;
    font-weight: 600;
    color: $aisea-white;
  }

  .right-area {
    min-width: 240px;
  }

  .caption-image {
    img {
      width: 850px;
    }
  }

  .step-area {
    display: flex;
    align-items: start;
    width: 100%;
    background-color: rgba($aisea-blue, 0.1);
    padding: 24px;
    .step-label {
      padding: 0 12px;
      border-radius: 16px;
      background-color: $aisea-blue;
      font-family: $aisea-font-family;
      text-align: center;
    }
    .step-number {
      color: $aisea-blue;
      font-size: 96px;
      font-family: $aisea-font-family;
      font-weight: 600px;
      line-height: 100%;
    }
    .step-title {
      color: $aisea-blue;
      font-size: 28px;
      font-family: $aisea-font-family;
      font-weight: bold;
      margin-bottom: 12px;
    }
    .step-subtitle {
      color: $aisea-blue;
      font-size: 20px;
      font-family: $aisea-font-family;
      font-weight: bold;
      margin-bottom: 8px;
    }

    .image-area {
      min-width: $image-area-width;
      max-width: $image-area-width;
      width: $image-area-width;
      margin-left: 16px;
      display: flex;
      justify-content: center;
      align-items: flex-start;
    }
  }

  .step-triangle {
    margin-top: -8px;
    border: 45px solid transparent;
    border-top: 35px solid $aisea-blue;
  }

  div.image-area img {
    width: 180px;
    height: auto;
  }
}
</style>
